import { createSelector } from 'reselect';
import { userSettings, userSmsSubscriptionStatus } from 'store/saga/entities/bound';
import { NOTIFICATION_TYPE_LIST } from './Notifications.constants';

export const selectUserSettingsIsLoaded = state => userSettings.loaded(state);
const selectUserSettingsData = createSelector(
  state => state,
  selectUserSettingsIsLoaded,
  (state, isLoaded) => (isLoaded ? userSettings.data(state) : { settingsByVenue: [] })
);

export const selectReceiveNotifications = createSelector(
  selectUserSettingsIsLoaded,
  selectUserSettingsData,
  (isLoaded, { settingsByVenue }) => {
    return NOTIFICATION_TYPE_LIST.reduce(
      (acc, type) => ({
        ...acc,
        [type]: !isLoaded
          ? []
          : settingsByVenue.reduce(
              (settingsList, { venueId, settings }) =>
                settings[type] ? [...settingsList, `${venueId}`] : settingsList,
              []
            ),
      }),
      {}
    );
  }
);

export const selectUserSmsSubscriptionStatusIsLoaded = state => userSmsSubscriptionStatus.loaded(state);
const selectUserSmsSubscriptionStatusData = createSelector(
  state => state,
  selectUserSmsSubscriptionStatusIsLoaded,
  (state, isLoaded) =>
    isLoaded ? userSmsSubscriptionStatus.data(state) : { optedIn: false, countryCode: null, phone: null }
);

export const selectUserSmsSubscriptionStatus = createSelector(
  selectUserSmsSubscriptionStatusIsLoaded,
  selectUserSmsSubscriptionStatusData,
  (isLoaded, { optedIn }) => (!isLoaded ? false : optedIn)
);

export const selectUserSmsPhoneNumber = createSelector(
  selectUserSmsSubscriptionStatusIsLoaded,
  selectUserSmsSubscriptionStatusData,
  (isLoaded, { countryCode, phone }) => {
    if (!isLoaded) {
      return '';
    }
    return phone !== null && countryCode !== null ? `${countryCode}${phone}` : '';
  }
);
